/*
 * Install and configure Fathom analytics
 */

const FathomConfig = {
  src: 'https://cdn.usefathom.com/script.js',
  site: 'QRDGMSAW'
};

const logMockCallsToFathomInDevelopment = false;

export default () => {
  const allowTracking = window.Cypress ? true : process.env.NODE_ENV === 'production';

  if (!allowTracking) return;
  /* Create a script tag and insert it into the dom */
  ((accessor) => {
    window[accessor] =
      window[accessor] ||
      function () {
        (window[accessor].q = window[accessor].q || []).push(arguments);
      };
    const scriptElement = document.createElement('script');
    const firstScriptElement = document.getElementsByTagName('script')[0];
    scriptElement.async = 1;
    scriptElement.src = FathomConfig.src;
    scriptElement.id = 'fathom-script';
    scriptElement.setAttribute('data-site', FathomConfig.site);
    firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);
  })('fathom');

  /* Now configure fathom, only if it has not been configured already (once configured it is an object) */
  if (typeof fathom === 'function') fathom('set', 'siteId', FathomConfig.site);
};

export const sendPageview = (url) => {
  const fathomParams = url ? { url } : {};
  const allowTracking = window.Cypress ? true : process.env.NODE_ENV === 'production';
  if (!allowTracking && logMockCallsToFathomInDevelopment) {
    console.log(
      'Mock pageview to fathom when not in production environment',
      fathomParams
    );
  } else if (window.fathom && window.fathom.trackPageview) {
    window.fathom.trackPageview(fathomParams);
  }
};
